import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import TableView from "../TableView";

export default function InfoStep01() {

  const { getValues } = useFormContext()
  const { step01 } = getValues()

  return (
    <>
      <Typography mb={0.5} variant="subtitle1">
        {step01.publico_dado.tipo_publico}{step01.publico_dado.codigo_publico} - {step01.publico_dado.nome_pessoa}</Typography>

      <Box display={'flex'} gap={4}>
        <TableView
          title="Código"
          text={`${step01.tipo_documento.id}-${step01.numero_documento}`}
        />
        <TableView
          title="Série"
          text={`${step01.serie}`}
        />
      </Box>
    </>
  )
}
